import { useState } from 'react';
import loadable from '@loadable/component';

import InformationSolid from '@simplywallst/ui-core/icons/InformationSolid';

const ReturnsInformationModal = loadable(
  () => import('./ReturnsInformationModal'),
  {
    resolveComponent: (c) => c.ReturnsInformationModal,
  }
);

export const ReturnsCalculationButton = () => {
  const [showInformationModal, setShowInformationModal] = useState(false);

  return (
    <>
      <button
        className="grid grid-cols-[max-content_max-content] items-center gap-x0_5"
        onClick={() => setShowInformationModal(true)}
      >
        <InformationSolid className="fill-soft" />
        <p className="m-0 text-xs text-soft">
          <span className="hidden md:inline">How returns are calculated?</span>
          <span className="inline md:hidden">Returns calculation</span>
        </p>
      </button>
      {showInformationModal && (
        <ReturnsInformationModal
          onClose={() => setShowInformationModal(false)}
        />
      )}
    </>
  );
};
